/**
 * Savage Lab — carga diferida de video, sin librerías.
 *
 * Los <source> vienen con `data-src` en vez de `src`, así que el navegador no
 * descarga un solo byte de video al abrir la página. Cuando el bloque se acerca
 * a la pantalla se copian las fuentes y empieza la reproducción; cuando sale de
 * vista se pausa, para no gastar CPU ni batería.
 */
class SlVideoLazy extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    if (!this.video) return;

    // Sin IntersectionObserver (navegadores viejos): cargar y ya.
    if (!('IntersectionObserver' in window)) {
      this.activar();
      return;
    }

    // Margen generoso: empieza a descargar un poco antes de que se vea,
    // para que no se note el salto del póster al video.
    this.observador = new IntersectionObserver(
      (entradas) => entradas.forEach((e) => this.alCruzar(e)),
      { rootMargin: '200px 0px', threshold: 0.01 }
    );
    this.observador.observe(this);
  }

  disconnectedCallback() {
    if (this.observador) this.observador.disconnect();
  }

  alCruzar(entrada) {
    if (entrada.isIntersecting) {
      this.activar();
      this.reproducir();
    } else {
      this.pausar();
    }
  }

  activar() {
    if (this.activado) return;
    this.activado = true;
    this.querySelectorAll('source[data-src]').forEach((s) => {
      s.src = s.dataset.src;
      s.removeAttribute('data-src');
    });
    this.video.load();
    this.video.addEventListener(
      'playing',
      () => this.classList.add('sl-video--listo'),
      { once: true }
    );
  }

  reproducir() {
    // Si el usuario pidió menos movimiento, respetarlo y dejar solo el póster.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const p = this.video.play();
    if (p && p.catch) p.catch(() => {}); // autoplay bloqueado: se queda el póster
  }

  pausar() {
    if (this.video && !this.video.paused) this.video.pause();
  }
}

if (!customElements.get('sl-video-lazy')) {
  customElements.define('sl-video-lazy', SlVideoLazy);
}
